import { useIntlModule } from 'utils/intl/useIntlModule';
import userInterfaceSettingsMessages from './userInterfaceSettings.intl.json';

export const useUserInterfaceSettingsIntl = () => useIntlModule(userInterfaceSettingsMessages);
